export default __webpack_public_path__ + "static/prompt-latin-400-normal-03568dfaabfa694e7a08dea08a08c401.woff2";